// Thin wrapper around the official @rails/request.js helper.
//
// Centralizes what was previously duplicated across ~30 Stimulus controllers:
// CSRF token injection, standard Accept headers and automatic Turbo Stream
// rendering. We delegate all of that to @rails/request.js (already a project
// dependency) and only add a couple of ergonomic conveniences on top.
//
// Usage:
//   import { request } from "../lib/request"
//   await request.post(url, { body: formData })             // FormData/Turbo Stream
//   const data = await request.get(url, { responseKind: "json" }).then(r => r.json)
//
// Turbo Stream responses (status 200/422 + text/vnd.turbo-stream.html) are
// rendered automatically by @rails/request.js because we expose window.Turbo.

import { Turbo } from "@hotwired/turbo-rails"
import { get, post, patch, put, destroy } from "@rails/request.js"

// Required so @rails/request.js can auto-process turbo-stream responses.
if (!window.Turbo) window.Turbo = Turbo

// Re-export the verb helpers under a single namespace. Each returns a
// FetchResponse (with .ok, .json, .html, .statusCode, .unprocessableEntity…).
export const request = {
  get,
  post,
  patch,
  put,
  delete: destroy,
  destroy,
}

export { get, post, patch, put, destroy }
export default request
